/*
 * @Author: CN\yangtianyu01 ../AuditExceptionp.netease.com
 * @Date: 2025-12-16 21:24:03
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-12-18 14:00:00
 * @FilePath: \mpc-3\features\mpc-common\src\features\MPCDemand\bindAiReviewResultToFormItem.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import AuditException, { AuditExceptionProps } from "../AuditException";
import { DemandAiReviewResultItemDto } from "#services/api";


export const matchAiReviewResultItemKey = (aiReviewResultItemKey: string, aiReviewResultItems: DemandAiReviewResultItemDto[]) => {
    return aiReviewResultItems?.find((item) => item?.item_id === aiReviewResultItemKey);
}

export function bindAiReviewResultToFormItem(aiReviewResultItemKey: string, propRenderData: any = undefined, audioExceptionProps: AuditExceptionProps = {}) {
    const getReviewResult = (renderData: any, itemProps: any) => {
        const localDetailData = propRenderData?.detailData || renderData?.detailData || {};
        const reviewResults = localDetailData?.demand_aireview_result?.items || [] as DemandAiReviewResultItemDto[];
        const reviewResult = reviewResults?.find((item) => item?.item_id === aiReviewResultItemKey);
        return reviewResult;
    } 
    return {
        parentHighlightColor: (renderData, itemProps) => {
            const reviewResult = getReviewResult(renderData, itemProps);
            if (!reviewResult) return undefined;
            return "light-orange";
          },
        renderAfterSlot: (renderData, itemProps) => {
          const reviewResult = getReviewResult(renderData, itemProps);
          if (!reviewResult) return undefined;
          return (
            <AuditException
              {...audioExceptionProps}
              data={reviewResult}
            />
          );
        },
    }
  
}
